/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_StudyType {
    NONE = 'None',
    CLASSIC = 'Classic',
    SESSION_CLUSTER = 'SessionCluster',
    OPEN_RECRUITMENT = 'OpenRecruitment',
    PANELIST = 'Panelist',
    ANONYMOUS = 'Anonymous',
    EXTERNAL = 'External',
    COMMUNITY = 'Community',
    CALENDAR = 'Calendar',
}
